// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/GradientBGtest.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html{
    height: 100%;
    margin: 0 auto;
}

body{
    height: 100%;
    margin: 0 auto;
}

.menu-bar{
    border-bottom: 1px #c7c7c7 solid;
}
.scrolled{
    height: 5vh;
}
@media only screen and (max-width: 1280px) {
    .secondary-header-image {
        -webkit-transform: translate3d(0,0,0);
    }
}
    .secondary-header-image {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-attachment: fixed;
        padding: 0;
    }

    .menu-text {
        font-family: 'Raleway', sans-serif;
        font-weight: 100;
    }

    .main-header {
        font-family: 'Roboto', sans-serif;
        font-weight: 900;
    }

    .section-header {
        font-family: 'Roboto', sans-serif;
        font-weight: 100;
    }

    .context-text {
        font-family: 'Raleway', sans-serif;
        font-weight: 300;
    }

    .section-subheading {
        font-family: 'Roboto', sans-serif;
        font-weight: 100;
        font-style: italic;
    }

    .text-roboto {
        font-family: 'Roboto', sans-serif;
    }

    b {
        font-weight: 600;
    }

    :root {
        --animate-delay: 0.25s;
    }

    .divider-line {
        background: linear-gradient(90deg, #955687 -1.2%, rgba(149, 86, 135, 0.00) 100%);
    }
    .divider-line-2 {
        background: linear-gradient(90deg, #17849D -1.2%, #17849D 100%);
    }

    .choose-grad {
        background: linear-gradient(180deg, rgba(23, 132, 157, 0.10) 0%, rgba(149, 86, 135, 0.10) 100%);
    }


    @media only screen and (max-width: 1280px) {
        .stack-cards__item {
            position: sticky;
            top: 0.75em;
            transform-origin: center top;
        }

        .outline-text {
            -webkit-text-stroke: 1px #ffffff;
            -webkit-text-fill-color: transparent;
        }
    }

    @media only screen and (min-width: 1280px) {
        .stack-cards__item {
            position: relative;
        }

        .outline-text {
            -webkit-text-stroke: 3px #ffffff;
            -webkit-text-fill-color: transparent;
        }
        .reverse-profile
        {
            flex-direction: row-reverse;
        }
    }
    
`, "",{"version":3,"sources":["webpack://./src/css/stylesheet.css"],"names":[],"mappings":"AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,gCAAgC;AACpC;AACA;IACI,WAAW;AACf;AACA;IACI;QACI,qCAAqC;IACzC;AACJ;IACI;QACI,yDAAkD;QAClD,4BAA4B;QAC5B,0BAA0B;QAC1B,4BAA4B;QAC5B,UAAU;IACd;;IAEA;QACI,kCAAkC;QAClC,gBAAgB;IACpB;;IAEA;QACI,iCAAiC;QACjC,gBAAgB;IACpB;;IAEA;QACI,iCAAiC;QACjC,gBAAgB;IACpB;;IAEA;QACI,kCAAkC;QAClC,gBAAgB;IACpB;;IAEA;QACI,iCAAiC;QACjC,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gFAAgF;IACpF;IACA;QACI,+DAA+D;IACnE;;IAEA;QACI,+FAA+F;IACnG;;;IAGA;QACI;YACI,gBAAgB;YAChB,WAAW;YACX,4BAA4B;QAChC;;QAEA;YACI,gCAAgC;YAChC,oCAAoC;QACxC;IACJ;;IAEA;QACI;YACI,kBAAkB;QACtB;;QAEA;YACI,gCAAgC;YAChC,oCAAoC;QACxC;QACA;;YAEI,2BAA2B;QAC/B;IACJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');\r\n\r\nhtml{\r\n    height: 100%;\r\n    margin: 0 auto;\r\n}\r\n\r\nbody{\r\n    height: 100%;\r\n    margin: 0 auto;\r\n}\r\n\r\n.menu-bar{\r\n    border-bottom: 1px #c7c7c7 solid;\r\n}\r\n.scrolled{\r\n    height: 5vh;\r\n}\r\n@media only screen and (max-width: 1280px) {\r\n    .secondary-header-image {\r\n        -webkit-transform: translate3d(0,0,0);\r\n    }\r\n}\r\n    .secondary-header-image {\r\n        background-image: url(\"../img/GradientBGtest.svg\");\r\n        background-repeat: no-repeat;\r\n        background-size: 100% 100%;\r\n        background-attachment: fixed;\r\n        padding: 0;\r\n    }\r\n\r\n    .menu-text {\r\n        font-family: 'Raleway', sans-serif;\r\n        font-weight: 100;\r\n    }\r\n\r\n    .main-header {\r\n        font-family: 'Roboto', sans-serif;\r\n        font-weight: 900;\r\n    }\r\n\r\n    .section-header {\r\n        font-family: 'Roboto', sans-serif;\r\n        font-weight: 100;\r\n    }\r\n\r\n    .context-text {\r\n        font-family: 'Raleway', sans-serif;\r\n        font-weight: 300;\r\n    }\r\n\r\n    .section-subheading {\r\n        font-family: 'Roboto', sans-serif;\r\n        font-weight: 100;\r\n        font-style: italic;\r\n    }\r\n\r\n    .text-roboto {\r\n        font-family: 'Roboto', sans-serif;\r\n    }\r\n\r\n    b {\r\n        font-weight: 600;\r\n    }\r\n\r\n    :root {\r\n        --animate-delay: 0.25s;\r\n    }\r\n\r\n    .divider-line {\r\n        background: linear-gradient(90deg, #955687 -1.2%, rgba(149, 86, 135, 0.00) 100%);\r\n    }\r\n    .divider-line-2 {\r\n        background: linear-gradient(90deg, #17849D -1.2%, #17849D 100%);\r\n    }\r\n\r\n    .choose-grad {\r\n        background: linear-gradient(180deg, rgba(23, 132, 157, 0.10) 0%, rgba(149, 86, 135, 0.10) 100%);\r\n    }\r\n\r\n\r\n    @media only screen and (max-width: 1280px) {\r\n        .stack-cards__item {\r\n            position: sticky;\r\n            top: 0.75em;\r\n            transform-origin: center top;\r\n        }\r\n\r\n        .outline-text {\r\n            -webkit-text-stroke: 1px #ffffff;\r\n            -webkit-text-fill-color: transparent;\r\n        }\r\n    }\r\n\r\n    @media only screen and (min-width: 1280px) {\r\n        .stack-cards__item {\r\n            position: relative;\r\n        }\r\n\r\n        .outline-text {\r\n            -webkit-text-stroke: 3px #ffffff;\r\n            -webkit-text-fill-color: transparent;\r\n        }\r\n        .reverse-profile\r\n        {\r\n            flex-direction: row-reverse;\r\n        }\r\n    }\r\n    \r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
